import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SvgIcon, Button, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import ShieldCheckmarkIcon from '../../../icons/shield-checkmark.svg?react';
import NeedsCalculator from './NeedsCalculator';
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import './NeedsAnalysisStackedButton.scss';


export default function NeedsAnalysisStackedButton(props) {
  const navigate = useNavigate();

  const title = props.title || "NEEDS ANALYSIS";
  const toolName = props.toolName;

  const [modalNeedsCalculatorIsOpen, setModalNeedsCalculatorIsOpen] = useState(false);

  const setCoverageAmount = (face) => {
    if (props.setCoverageAmount != null) {
      props.setCoverageAmount(face)
    }
    else {
      sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, face);
      navigate("/landing/term-insurance");
    }
  };

  const modalNeedsCalculatorFields = {
    modalNeedsCalculatorIsOpen: modalNeedsCalculatorIsOpen,
    setModalNeedsCalculatorIsOpen: setModalNeedsCalculatorIsOpen,
    setCoverageAmount: setCoverageAmount,
    minCoverageAmount: props.minCoverageAmount || 250000,
    maxCoverageAmount: props.maxCoverageAmount || 10000000,
  };

  const handleToolTip = (e) => {
    e.stopPropagation();
  };

  return (
    <Fragment>
      {props.condensed ?
        <div className="needs-analysis-basic-button">
          <Button type="button"
            onClick={() => setModalNeedsCalculatorIsOpen(true)}
            variant={props.isPrequote ? undefined : undefined}
            color="primary"
            className={`quote-needs-button white-primary-button`}
          >
            {toolName}
            <span className="help-container" onClick={handleToolTip}>
              <Tooltip
                title={props.title}
                enterTouchDelay={0}
                slotProps={{
                  tooltip: {
                    className: 'light-tooltip',
                    sx: { fontSize: '11px' }
                  },
                }}>
                <InfoOutlinedIcon className='help-tooltip' fontSize="small" />
              </Tooltip>
            </span>
          </Button>
        </div>
        :
        <div className="needs-analysis-stacked-button">
          <Button type="submit"
            onClick={() => setModalNeedsCalculatorIsOpen(true)}
            variant={props.isPrequote ? undefined : undefined}
            color="primary"
            className={`quote-needs-button white-primary-button`}
          >
            {props.isPrequote ? <SvgIcon component={ShieldCheckmarkIcon} color="primary" /> : <div className={`icon-container mb-0 background-color-16`}><SvgIcon component={ShieldCheckmarkIcon} color="primary" /></div>}
            <h3 className="tool-name">{toolName}</h3>
            <span className="name">&nbsp;{title}</span>
          </Button>

        </div>
      }
      <NeedsCalculator fields={modalNeedsCalculatorFields} isPrequote={props.isPrequote} isCustomTerm={props.isCustomTerm} />
    </Fragment>
  );
}

NeedsAnalysisStackedButton.propTypes = {
  minCoverageAmount: PropTypes.number,
  maxCoverageAmount: PropTypes.number,
};
